var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 3C8.44772 3 8 3.44772 8 4V5.29289C6.16918 5.71255 4.71255 7.16918 4.29289 9H3C2.44772 9 2 9.44772 2 10V13C2 13.5523 2.44772 14 3 14H4.29289C4.71255 15.8308 6.16918 17.2874 8 17.7071V19C8 19.5523 8.44772 20 9 20H15C15.5523 20 16 19.5523 16 19V17.7071C17.8308 17.2874 19.2874 15.8308 19.7071 14H21C21.5523 14 22 13.5523 22 13V10C22 9.44772 21.5523 9 21 9H19.7071C19.2874 7.16918 17.8308 5.71255 16 5.29289V4C16 3.44772 15.5523 3 15 3H9ZM10 5H14V6.5C14 6.77614 13.7761 7 13.5 7H10.5C10.2239 7 10 6.77614 10 6.5V5ZM7 10.5C7 9.67157 7.67157 9 8.5 9C9.32843 9 10 9.67157 10 10.5C10 11.3284 9.32843 12 8.5 12C7.67157 12 7 11.3284 7 10.5ZM15.5 9C14.6716 9 14 9.67157 14 10.5C14 11.3284 14.6716 12 15.5 12C16.3284 12 17 11.3284 17 10.5C17 9.67157 16.3284 9 15.5 9ZM8 14.5C8 14.2239 8.22386 14 8.5 14H15.5C15.7761 14 16 14.2239 16 14.5C16 14.7761 15.7761 15 15.5 15H8.5C8.22386 15 8 14.7761 8 14.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpot);
export default __webpack_public_path__ + "static/media/SPOT.46d7b98a9fe3f1101c2ee6d080bed088.svg";
export { ForwardRef as ReactComponent };